import { Button, Col, Flex, Popconfirm, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { API_ROUTE } from '../../../utils/commonConstants';
import { GET } from '../../../utils/requestActionConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { reviewTabConfig } from '../ReviewTab';
import { useDispatch, useSelector } from 'react-redux';
import { setReviews, setReview, updateReview, deleteReview } from '../../../store/slices/reviewSlice';
import SearchComponent from '../../../components/SearchComponent';
import CsvLink from 'react-csv-export';
import PDFListDownloader from '../../../components/PDFListDownloader';
import { setUsers } from '../../../store/slices/userSlice';
import { setProductsList } from '../../../store/slices/productSlice';


function ReviewList({ onSwitchTab }) {
  const dataFetcher = useSWR({ method: GET, url: API_ROUTE + '/reviews' }, fetcher);
  const userDataFetcher = useSWR({ method: GET, url: API_ROUTE + '/users' }, fetcher);
  const productsDataFetcher = useSWR({ method: GET, url: API_ROUTE + '/products' }, fetcher);
  const state = useSelector(state => state.reviewSlice);
  const dispatch = useDispatch();
  const [filteredData, setFilteredData] = useState([]);

  const edit = (data) => {
    dispatch(setReview(data))
    onSwitchTab(reviewTabConfig.ADD, data);
  }

  useEffect(() => {
    if (dataFetcher.data?.data) {
      dispatch(setReviews(dataFetcher.data.data));
    }
  }, [dataFetcher.data?.data, userDataFetcher.data?.data])

  useEffect(() => {
    if (userDataFetcher.data?.data) {
      dispatch(setUsers(userDataFetcher.data.data));
    }
  }, [userDataFetcher.data?.data])

  useEffect(() => {
    if (productsDataFetcher.data?.data) {
      dispatch(setProductsList(productsDataFetcher.data.data));
    }
  }, [productsDataFetcher.data?.data])

  const onDeleteRecord = (record) => {
    dispatch(deleteReview({ reviewId: record.id }));
  }

  const columns = [
    {
      title: 'Comment',
      dataIndex: 'comment',
      key: 'comment',
    },
    {
      title: 'Rating',
      dataIndex: 'rating',
      key: 'rating',
    },
    {
      title: 'User',
      dataIndex: 'user',
      key: 'user',
      render: (_, record) => (
        <div>{record.user?.name}</div>
      )
    },
    {
      title: 'Product',
      dataIndex: 'product',
      key: 'product',
      render: (_, record) => (
        <div>{record.product?.name}</div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          <div>
            <Button onClick={() => edit(record)}>Amend</Button>
            <Popconfirm title="Delete" description="Are you sure to delete this record?" onConfirm={() => onDeleteRecord(record)}
              okText="Yes"
              cancelText="No"
            >
              <Button danger type='primary'>Delete</Button>
            </Popconfirm>
          </div>
        </>
      )
    }
  ];

  const pdfDownloadColumns = [
    { key: "id", label: "ID" },
    { key: "comment", label: "Comment" },
    { key: "productId", label: "Product" },
    { key: "userId", label: "User" },
    { key: "rating", label: "Rating" },
    { key: "status", label: "Status" },
  ];

  const onFilter = (filteredData) => {
    setFilteredData(filteredData);
  }

  return (
    <Row gutter={[16, 16]}>
      <Flex justify='space-between' className='w-full pr-3'>
        <SearchComponent masterData={state.reviewList} onFilter={onFilter} filterByKeys={['comment', 'rating']} />
        <Flex content='center'>
          <CsvLink data={state.reviewList} fileName="weda_arana_data" withTimeStamp>
            <div className='text-right text-lg'><Button>CSV</Button></div>
          </CsvLink>
          <PDFListDownloader records={state.reviewList} columns={pdfDownloadColumns} />
        </Flex>
      </Flex>
      <Col span={24}>
        <div>
          <Table columns={columns} dataSource={filteredData} pagination={false} loading={dataFetcher.isLoading} />
        </div>
      </Col>
    </Row>
  );
}

export default ReviewList